export default "__VITE_ASSET__D5pf3_nB__"